import { Link } from "react-router-dom";
import { GoogleDriveLogo } from "@phosphor-icons/react";

function formatBytes(b) {
  if (!b) return "0 B";
  const k = 1024, sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(b) / Math.log(k)), sizes.length - 1);
  return (b / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1) + " " + sizes[i];
}

export default function StorageBar({ user }) {
  const used = user?.storage_used_bytes || 0;
  const free = user?.free_storage_bytes || 1024 ** 3;
  const oneTimeGb = user?.extra_storage_gb || 0;
  const subGb = user?.subscription_gb || 0;
  const extraBytes = (oneTimeGb + subGb) * 1024 ** 3;
  const total = free + extraBytes;
  const pct = Math.min(100, (used / total) * 100);
  const drive = user?.drive_connected;

  return (
    <div className="border border-border rounded-lg bg-card p-6" data-testid="storage-bar">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Storage</p>
          <p className="font-serif text-2xl mt-1" data-testid="storage-usage-text">
            {formatBytes(used)} <span className="text-muted-foreground text-lg">/ {formatBytes(total)}</span>
          </p>
          {(oneTimeGb > 0 || subGb > 0) && (
            <p className="text-xs text-muted-foreground mt-1">
              {subGb > 0 && `+${subGb} GB monthly`}
              {subGb > 0 && oneTimeGb > 0 && " · "}
              {oneTimeGb > 0 && `+${oneTimeGb} GB top-up`}
            </p>
          )}
        </div>
        <div className="text-right">
          {drive ? (
            <span
              data-testid="drive-connected-badge"
              className="text-xs uppercase tracking-[0.2em] text-primary flex items-center gap-1"
            >
              <GoogleDriveLogo size={14} weight="duotone" /> Drive connected
            </span>
          ) : (
            <Link
              to="/storage"
              data-testid="storage-upgrade-link"
              className="text-xs uppercase tracking-[0.2em] font-semibold text-accent hover:underline"
            >
              Get more →
            </Link>
          )}
        </div>
      </div>
      <div className="h-1 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-[width] duration-500"
          style={{ width: `${pct}%` }}
          data-testid="storage-progress"
        />
      </div>
      <p className="text-xs text-muted-foreground mt-3">
        {drive
          ? "Uploads route to your Google Drive automatically — no storage limit."
          : "1 GB free · ₹100/GB/month or connect Google Drive for unlimited."}
      </p>
    </div>
  );
}
